  <div>
    <h1 class="app">Responsive Contractor Insurance Program</h1>
  </div>
  

  <div class="w-full flex justify-between mt-5 gap-100">
    <div class="w-full lg:w-2/3">
      <h2 class="app">General Liability</h2>
      <p class="large pt-1">The Responsive Contractor Insurance Program allows producers to customize coverage through optional forms selection when quoting each risk, and influence pricing with the application of pricing credits.</p>

      <h2 class="app mt-20">Underwriting Criteria</h2>
      <ol>
        <li><p class="large">A signed contractor's supplemental application must be provided at time of binding.</p></li>
        <li><p class="large">Loss History for prior five years. Accounts with losses must be referred to underwriting.</p></li>
        <li><p class="large">Currently valued loss runs for the past five years are required to remove the prior work exclusion.</p></li>
       </ol>

      <h2 class="app mt-20">States Available</h2>
      <p class="large mt-3">Arizona, California, Nevada, Utah and Washington</p>
      <h3 class="underline-container mt-20 mb-3">Eligibility</h3>
      @for (item of programStatementSections; track $index) {
        <div [innerHTML]="item.statement"></div>
      }
      
      <h3 class="underline-container mt-20 mb-3"> Classifications</h3>
      <lib-class-accordion [accordions]="classStatements" class="mt-20"></lib-class-accordion>

    </div>
    <div class="w-full lg:w-1/3">
        <img src="/assets/images/logo-RCIP-portal.png" alt="rcpi logo">
        <h3 class="app">Program Highlights</h3>
        
        <ul class="ul-reset circleCheck ">
         <li>Minimum Premium As Low As $500</li>
         <li>A-VIII Paper - {{ isPastJuly2026 ? ' Insurance Company' : 'Highlander Specialty' }}</li>
         <li>New Residential Construction OK - All Classes</li>
         @if (!isPastJuly2026) {
           <li>Homebuilders OK</li>
         }
         <li>Unlimited Sub Exposure OK</li>
         <li>Add $5M Project Aggregate Blanket</li>
         <li>Increase Work Height Limitation</li>
          <li>Blanket Ongoing & Completed Ops AI's Included</li>
        </ul>

        <h3 class="app mt-20">Minimum Premiums</h3>
        <div class="minprem-container">
          <p>Most Artisan Classes</p>
          <p>$500</p>
        </div>
        <div class="minprem-container">
          <p>Air Conditioning</p>
          <p>$750</p>
        </div>
        <div class="minprem-container">
          <p>HVAC</p>
          <p>$750</p>
        </div>
        <div class="minprem-container">
          <p>Commercial Refrigeration</p>
          <p>{{ isPastJuly2026 ? '$1,000' : '$750' }}</p>
        </div>
        <div class="minprem-container">
          <p>Finish Carpentry</p>
          <p>$800</p>
        </div>
        <div class="minprem-container">
          <p>Remodeling</p>
          <p>{{ isPastJuly2026 ? '$650' : '$800' }}</p>
        </div>
        <div class="minprem-container">
          <p>Excavation</p>
          <p>$1,000</p>
        </div>
        <div class="minprem-container">
          <p>Grading</p>
          <p>$1,000</p>
        </div>
        <div class="minprem-container">
          <p>Glass Dealers & Glaziers</p>
          <p>$1,000</p>
        </div>
        <div class="minprem-container">
          <p>Metal Erection - Decorative</p>
          <p>$1,000</p>
        </div>
        <div class="minprem-container">
          <p>Metal Erection - Nonstructural</p>
          <p>$1,000</p>
        </div>
        <div class="minprem-container">
          <p>Septic Installation</p>
          <p>$1,000</p>
        </div>
        <div class="minprem-container">
          <p>Tree Trimming</p>
          <p>$1,500</p>
        </div>
        @if (!isPastJuly2026) {
          <div class="minprem-container">
            <p>Homebuilders</p>
            <p>$2,500</p>
          </div>
        }
        <div class="minprem-container">
          <p>Siding Installation</p>
          <p>$2,500</p>
        </div>
        <div class="minprem-container">
          <p>Plumbing - Commercial</p>
          <p>$3,000</p>
        </div>
        <div class="minprem-container">
          <p>Plumbing - Residential</p>
          <p>$3,000</p>
        </div>
        <!-- <div class="py-3">
          <h3 class="app">Downloads</h3>
          <lib-button class="primary underline" [cssType]="'btn-link'"  [text]="'Responsive Contractor Insurance Underwriting Guidelines'" [buttonType]="'link'" [externalLink]="true" [href]="'https://affiliatedmembersinsurance.com/Portals/0/Downloads/RCIP-responsive-contractor-program-guidelines-060325.pdf'" ></lib-button>
        </div> -->
        
        <div class="py-3">
          <lib-button [cssType]="'btn-primary'" [buttonType]="'link'" [text]="'Quote Now'" [size]="'large'" [routerLink]="'/quote/new'" ></lib-button>
        </div>
  </div>
